import { FilePreviewDialog } from "components/filePreview/FilePreviewDialog";
import { NotificationsDialog } from "components/notifications/NotificationsDialog";
import ConnectionStatusProvider from "context/ConnectionStatus";
import PartnerConsentProvider from "context/PartnerConsentProvider";
import { LocationSettingsDialog } from "pages/dialogs/LocationSettingsDialog";
import { QueueDialog } from "pages/dialogs/QueueDialog";
import { ComponentType, FC } from "react";
import { MenuAppBar } from "./appBar/MenuAppBar";
import { AutoSyncDocumentsSettingsDialog } from "./dialogs/AutoSyncDocumentsSettingsDialog";

interface PartnerRouteProps {
  component: ComponentType<any>;
}

export const PartnerRoute: FC<PartnerRouteProps> = ({ component: Component }) => {
  return (
    <PartnerConsentProvider>
      <ConnectionStatusProvider>
        <MenuAppBar partnerView />
        <Component />
        <QueueDialog />
        <LocationSettingsDialog />
        <AutoSyncDocumentsSettingsDialog />
        <FilePreviewDialog />
        <NotificationsDialog partnerView />
      </ConnectionStatusProvider>
    </PartnerConsentProvider>
  );
};
